module.exports = __webpack_public_path__ + "static/media/11d.6a757f8e.svg";